import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "./auth/supabase";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);     // recovery session present
  const [checking, setChecking] = useState(true);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Supabase reads the token from the email link and creates a temporary session.
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY" || session) {
        setReady(true);
        setChecking(false);
      }
    });
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setReady(true);
      // give the URL token a moment to be processed before declaring it invalid
      setTimeout(() => setChecking(false), 1500);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const mismatch = confirm.length > 0 && password !== confirm;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords don’t match. Please re-enter them.");
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (error) return setError(error.message);
    setDone(true);
    setTimeout(() => navigate("/history", { replace: true }), 1800);
  };

  return (
    <section className="login-wrap" style={{ gridTemplateColumns: "1fr", maxWidth: 520 }}>
      <div className="login-card">
        {checking && !ready ? (
          <>
            <h2>Checking your link…</h2>
            <p className="sub">One moment.</p>
          </>
        ) : !ready ? (
          <>
            <h2>This link has expired.</h2>
            <p className="sub">
              Reset links only work once and expire after an hour. Request a new one from the login page.
            </p>
            <Link to="/login" className="submit" style={{ display: "block", textAlign: "center", textDecoration: "none" }}>
              Back to login →
            </Link>
          </>
        ) : done ? (
          <>
            <h2>Password updated.</h2>
            <div className="auth-msg info" role="status">You’re signed in. Taking you to your history…</div>
          </>
        ) : (
          <>
            <h2>Set a new password.</h2>
            <p className="sub">Choose something at least 8 characters long.</p>
            {error && <div className="auth-msg error" role="alert">{error}</div>}
            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <label htmlFor="newPw">New password</label>
                <div className="input-wrap">
                  <input
                    id="newPw"
                    type={showPw ? "text" : "password"}
                    autoComplete="new-password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button type="button" className="toggle-pw" onClick={() => setShowPw((s) => !s)}
                    aria-label={showPw ? "Hide password" : "Show password"}>
                    {showPw ? "Hide" : "Show"}
                  </button>
                </div>
              </div>
              <div className="field">
                <label htmlFor="confirmNewPw">Confirm new password</label>
                <div className={"input-wrap" + (mismatch ? " mismatch" : "")}>
                  <input
                    id="confirmNewPw"
                    type={showPw ? "text" : "password"}
                    autoComplete="new-password"
                    placeholder="Re-enter password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                  />
                </div>
                {mismatch && <p className="field-error">Passwords don’t match yet.</p>}
              </div>
              <button className="submit" type="submit" disabled={busy}>
                {busy ? "Saving…" : "Update password →"}
              </button>
            </form>
          </>
        )}
      </div>
    </section>
  );
}
